import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { config } from '../config';

function Callback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const called = useRef(false);

  useEffect(() => {
    if (called.current) {
      return;
    }
    called.current = true;

    const handleCallback = async () => {
      try {
        const code = searchParams.get('code');
        const scope = searchParams.get('scope');
        const signupToken = searchParams.get('state');

        if (!code) {
          setError('No authorization code received');
          setLoading(false);
          return;
        }

        if (!signupToken) {
          setError('Invalid signup session. Please start over.');
          setLoading(false);
          return;
        }

        const response = await axios.post(
          `${config.getBackendUrl()}/complete_signup`,
          new URLSearchParams({
            signup_token: signupToken,
            code: code,
            scope: scope,
          })
        );

        sessionStorage.setItem('sessionData', JSON.stringify(response.data));

        setLoading(false);
        
      } catch (err) {
        console.error('Error during callback:', err);
        setError(err.response?.data?.detail || err.response?.data?.message || 'Failed to authenticate');
        setLoading(false);
      }
    };

    handleCallback();
  }, [searchParams]);

  if (loading) {
    return (
      <div className="center-container">
        <div className="card">
          <h2>Authenticating...</h2>
          <div className="spinner" />
          <p className="loading">Please wait while we process your login</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="center-container">
        <div className="card">
          <h2>Authentication Failed</h2>
          <p className="error">{error}</p>
          <button
            className="button"
            onClick={() => navigate('/')}
            style={{ marginTop: '20px' }}
          >
            Back to Login
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="center-container">
      <div className="card">
        <h2>Welcome aboard!</h2>
        <p style={{ marginBottom: '12px' }}>
          Come back in <strong>10 minutes</strong> — we will have processed a good chunk of your data.
        </p>
        <p style={{ marginBottom: '24px', color: '#666' }}>
          For a complete history, visit us in a few hours.
        </p>
        <button
          className="button"
          onClick={() => navigate('/dashboard')}
        >
          Go to Dashboard
        </button>
      </div>
    </div>
  );
}

export default Callback;
